<app-loader [showLoader]="isLoading"></app-loader>

<ng-container *ngIf="processCompleted; else uploadSection">
  <div class="importResultWrap importFailed text-center" *ngIf="showErrors">
    <img class="topIcon" alt="icon" src="../assets/images/cancel.svg" />
    <h3 class="hdg">Import Failed</h3>
    <p class="des">
      To investigate the issues please download the log file, fix errors &
      upload again.
    </p>
    <button
      class="btn btn-colored importBtn text-center"
      role="button"
      (click)="downloadCsvFile(importFileType.ErrorLog)"
    >
      <img alt="icon" src="../assets/images/downloadCloud.svg" /> Download Log
      File
    </button>
  </div>
  <div class="importResultWrap importSuccess text-center" *ngIf="showSuccess">
    <img
      class="topIcon"
      alt="icon"
      src="../assets/images/auction-success.svg"
    />
    <h3 class="hdg">Import Successful</h3>
    <p class="des">
      {{ noOfUsersImported + " Users" }} |
      {{ noOfLotsImported + " Winning Lots" }} Imported
    </p>
    <ng-content select="[takeToAuctionButton]"></ng-content>
  </div>
</ng-container>

<!-- this is suppose to upload section  -->
<ng-template #uploadSection>
  <div class="importAuctionUserHeader">
    <div class="row">
      <div class="col-md-8">
        <h3>Registered Users</h3>
        <p>Import registered users to map them with winning lots</p>
      </div>
      <div class="col-md-4 text-md-right">
        <a
          class="btn btn-text px-0"
          role="button"
          (click)="downloadCsvFile(importFileType.AuctionUser)"
        >
          <img alt="download" src="../assets/images/icDownload.svg" />
          <span>Download Template</span>
        </a>
      </div>
    </div>
  </div>
  <div class="importUpload">
    <h4>Upload File</h4>
    <div class="importUploadBtn">
      <button
        class="btn btn-colored"
        role="button"
        (click)="browserUser.click()"
      >
        <svg
          width="16px"
          height="15px"
          viewBox="0 0 16 15"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Page-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="Create_New_Auction_Display_Details"
              transform="translate(-608.000000, -975.000000)"
              fill="#F7F7F7"
            >
              <g id="Group-4" transform="translate(607.000000, 974.000000)">
                <path
                  d="M16.44363,10.07215 C16.737642,10.07215 16.975242,10.30609 16.975242,10.59568 L16.975242,10.59568 L16.975242,14.7847 C16.975242,15.073285 16.737642,15.309085 16.44363,15.309085 L16.44363,15.309085 L1.555992,15.309085 C1.262448,15.309085 1.024452,15.07522 1.024452,14.7847 L1.024452,14.7847 L1.024452,10.59568 C1.024452,10.30609 1.262448,10.07215 1.555992,10.07215 C1.849536,10.07215 2.08809,10.30609 2.08809,10.59568 L2.08809,10.59568 L2.08809,14.26117 L15.91209,14.26117 L15.91209,10.59568 C15.91209,10.30609 16.14969,10.07215 16.44363,10.07215 Z M8.999802,1.69066 C9.13806,1.69066 9.275364,1.74205 9.380502,1.84603 L9.380502,1.84603 L12.568896,5.508175 C12.778128,5.71432 12.778128,6.04843 12.568896,6.25465 C12.35853,6.461185 12.018798,6.461185 11.809566,6.25465 L11.809566,6.25465 L9.53136,3.637615 L9.53136,11.642665 C9.53136,11.932255 9.293346,12.166135 8.999802,12.166135 C8.706276,12.166135 8.468262,11.932255 8.468262,11.642665 L8.468262,11.642665 L8.468262,3.637615 L6.190128,6.25465 C5.980806,6.46219 5.64156,6.46219 5.432238,6.25465 C5.222916,6.049495 5.222916,5.71432 5.432238,5.508175 L5.432238,5.508175 L8.619192,1.84603 C8.72433,1.74205 8.861562,1.69066 8.999802,1.69066 Z"
                  id="Combined-shape-1226"
                ></path>
              </g>
            </g>
          </g>
        </svg>
        Browse
      </button>

      <span class="browseFileName">
        <span class="mr-1">
          {{
            importForm.controls.auctionUser.value
              ? importForm.controls.auctionUser.value.name
              : "No File Chosen"
          }}
        </span>
        <img
          alt="cross"
          *ngIf="importForm.controls.auctionUser.value"
          src="../assets/images/cross.svg"
          role="button"
          (click)="removeFile(importForm.controls.auctionUser)"
        />
      </span>
      <control-messages
        [isFormSubmitted]="submitting"
        [control]="importForm.controls.auctionUser"
      ></control-messages>
    </div>
    <div>
      <input
        class="btn btn-colored browse-btn d-none"
        accept=".{{ fileExtension }}"
        type="file"
        (change)="uploadAuctionUser($event.target.files)"
        text="Browse"
        #browserUser
      />
    </div>
  </div>

  <div class="importAuctionUserHeader">
    <div class="row">
      <div class="col-md-8">
        <h3>Winning Lot Data</h3>
        <p>Import data for winning lots</p>
      </div>
      <div
        class="col-md-4 text-md-right"
        role="button"
        (click)="downloadCsvFile(importFileType.LotResult)"
      >
        <a class="btn btn-text px-0">
          <img alt="" src="../assets/images/icDownload.svg" />
          <span>Download Template</span>
        </a>
      </div>
    </div>
  </div>
  <div class="importUpload border-0">
    <h4>Upload File</h4>
    <div class="importUploadBtn">
      <button class="btn btn-colored" role="button" (click)="winning.click()">
        <svg
          width="16px"
          height="15px"
          viewBox="0 0 16 15"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Page-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="Create_New_Auction_Display_Details"
              transform="translate(-608.000000, -975.000000)"
              fill="#F7F7F7"
            >
              <g id="Group-4" transform="translate(607.000000, 974.000000)">
                <path
                  d="M16.44363,10.07215 C16.737642,10.07215 16.975242,10.30609 16.975242,10.59568 L16.975242,10.59568 L16.975242,14.7847 C16.975242,15.073285 16.737642,15.309085 16.44363,15.309085 L16.44363,15.309085 L1.555992,15.309085 C1.262448,15.309085 1.024452,15.07522 1.024452,14.7847 L1.024452,14.7847 L1.024452,10.59568 C1.024452,10.30609 1.262448,10.07215 1.555992,10.07215 C1.849536,10.07215 2.08809,10.30609 2.08809,10.59568 L2.08809,10.59568 L2.08809,14.26117 L15.91209,14.26117 L15.91209,10.59568 C15.91209,10.30609 16.14969,10.07215 16.44363,10.07215 Z M8.999802,1.69066 C9.13806,1.69066 9.275364,1.74205 9.380502,1.84603 L9.380502,1.84603 L12.568896,5.508175 C12.778128,5.71432 12.778128,6.04843 12.568896,6.25465 C12.35853,6.461185 12.018798,6.461185 11.809566,6.25465 L11.809566,6.25465 L9.53136,3.637615 L9.53136,11.642665 C9.53136,11.932255 9.293346,12.166135 8.999802,12.166135 C8.706276,12.166135 8.468262,11.932255 8.468262,11.642665 L8.468262,11.642665 L8.468262,3.637615 L6.190128,6.25465 C5.980806,6.46219 5.64156,6.46219 5.432238,6.25465 C5.222916,6.049495 5.222916,5.71432 5.432238,5.508175 L5.432238,5.508175 L8.619192,1.84603 C8.72433,1.74205 8.861562,1.69066 8.999802,1.69066 Z"
                  id="Combined-shape-1226"
                ></path>
              </g>
            </g>
          </g>
        </svg>
        Browse
      </button>

      <span class="browseFileName">
        <span class="mr-1">
          {{
            importForm.controls.lotResult.value
              ? importForm.controls.lotResult.value.name
              : "No File Chosen"
          }}
        </span>
        <img
          alt="cross"
          src="../assets/images/cross.svg"
          *ngIf="importForm.controls.lotResult.value"
          role="button"
          (click)="removeFile(importForm.controls.lotResult)"
        />
      </span>
      <control-messages
        [isFormSubmitted]="submitting"
        [control]="importForm.controls.lotResult"
      ></control-messages>
    </div>
    <div>
      <input
        class="btn btn-colored browse-btn d-none"
        accept=".{{ fileExtension }}"
        type="file"
        (change)="uploadLotResult($event.target.files)"
        text="Browse"
        #winning
      />
    </div>
  </div>

  <ng-container *ngIf="importForm.invalid && submitting">
    <p class="error-msg mb-4">Please resolve all the error(s) first</p>
  </ng-container>

  <div class="footerBtns">
    <ng-content select="[cancelButton]"></ng-content>
    <button class="btn btn-colored" role="button" (click)="uploadFiles()">
      Import
    </button>
  </div>
</ng-template>
